export default function formatPublishDate(date: string): string {
  // Publish date is in the format "YYYY-MM-DD"
  const [year, month, day] = date.split("-");
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return `${months[Number(month) - 1]} ${day}, ${year}`;
}
